import "clsx";
import { a4 as head, a5 as attr, a3 as derived } from "../../chunks/index.js";
import { toCssVariables, component, semantic, foundation, createComponent } from "@sentropic/design-system-tokens";
function html(value) {
  var html2 = String(value ?? "");
  var open = "<!---->";
  return open + html2 + "<!---->";
}
function assertTenantTheme(input) {
  if (!input || typeof input !== "object") {
    throw new Error("Theme must be an object");
  }
  const theme = input;
  if (typeof theme.id !== "string" || theme.id.trim().length === 0) {
    throw new Error("Theme id is required");
  }
  if (typeof theme.label !== "string" || theme.label.trim().length === 0) {
    throw new Error("Theme label is required");
  }
  if (theme.mode !== "light" && theme.mode !== "dark") {
    throw new Error("Theme mode must be light or dark");
  }
  if (!theme.tokens || typeof theme.tokens !== "object") {
    throw new Error("Theme tokens are required");
  }
}
function compileTheme(input, options = {}) {
  assertTenantTheme(input);
  const theme = input;
  const selector = options.selector ?? `[data-st-theme="${theme.id}"]`;
  const namespace = options.namespace ?? "st";
  return toCssVariables(theme.tokens, selector, namespace);
}
const sentTechTheme = {
  id: "sent-tech",
  label: "Sent Tech",
  mode: "light",
  tokens: {
    foundation,
    semantic,
    component
  }
};
const entropicSemantic = {
  ...semantic,
  action: {
    ...semantic.action,
    primary: "oklch(50% 0.134 242.749)",
    primaryText: semantic.action.primaryText
  }
};
const entropicComponent = createComponent(entropicSemantic, foundation);
const entropicTheme = {
  id: "entropic",
  label: "Entropic",
  mode: "light",
  tokens: {
    foundation,
    semantic: entropicSemantic,
    component: {
      ...entropicComponent,
      chat: {
        ...entropicComponent.chat,
        composerSurface: entropicSemantic.surface.raised,
        toolCallSurface: entropicSemantic.surface.subtle
      }
    }
  }
};
function ThemeProvider($$renderer, $$props) {
  $$renderer.component(($$renderer2) => {
    let { theme = sentTechTheme, namespace = "st", children } = $$props;
    let css = derived(() => compileTheme(theme, { selector: `[data-st-theme="${theme.id}"]`, namespace }));
    head("1lrpa8r", $$renderer2, ($$renderer3) => {
      $$renderer3.push(`${html(`<style data-st-theme-provider="${theme.id}">${css()}</style>`)}`);
    });
    $$renderer2.push(`<div${attr("data-st-theme", theme.id)}>`);
    children?.($$renderer2);
    $$renderer2.push(`<!----></div>`);
  });
}
function _layout($$renderer, $$props) {
  let { children } = $$props;
  ThemeProvider($$renderer, {
    theme: entropicTheme,
    children: ($$renderer2) => {
      children($$renderer2);
      $$renderer2.push(`<!---->`);
    }
  });
}
export {
  _layout as default
};
